(function() {

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function() {

    function normalizeRowHeights(selector) {
      var items = document.querySelectorAll(selector);
      if (!items.length) return;

      items.forEach(function(item) {
        item.style.minHeight = '';
      });

      var rows = {};
      items.forEach(function(item) {
        var top = Math.round(item.getBoundingClientRect().top);
        if (!rows[top]) rows[top] = [];
        rows[top].push(item);
      });

      Object.values(rows).forEach(function(row) {
        if (row.length < 2) return;
        var heights = row.map(function(item) { return item.scrollHeight; });
        var maxHeight = Math.max.apply(null, heights);
        var minHeightInRow = Math.min.apply(null, heights);
        if (maxHeight === minHeightInRow) return;
        row.forEach(function(item) {
          item.style.minHeight = maxHeight + 'px';
        });
      });
    }

    function normalizeAll() {
      normalizeRowHeights('.spf-product-card__title');
      normalizeRowHeights('.spf-product__swatchs');
      normalizeRowHeights('.globo-custom-stitching');
    }

    var timeout;
    function runNormalize() {
      clearTimeout(timeout);
      timeout = setTimeout(normalizeAll, 150);
    }

    normalizeAll();
    window.addEventListener('load', runNormalize);
    window.addEventListener('resize', runNormalize);

    setTimeout(runNormalize, 800);
    setTimeout(runNormalize, 2000);

    var observer = new MutationObserver(runNormalize);
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

  });

})();